import React, { useState } from "react";
import Toggle from "@atlaskit/toggle";
import Button from "@atlaskit/button/new";
import ConfirmModal from "../common/components/ConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import { saveFlow, selectFlow, setEditorSaved } from "../redux/actions/integrationActions";
import { useParams, useNavigate } from "react-router-dom";
import { Status } from "@atlaskit/status";
import TestFlowButton from "./testFlow/TestFlowButton";
import StopFlowButton from "./testFlow/StopFlowButton";
import { toggleLoading } from "../redux/actions/messageActions";
import Tooltip from "@atlaskit/tooltip";
import ArrowLeftIcon from "@atlaskit/icon/core/arrow-left";
import CreateButton from "./CreateButton";
import FlowRunner from "./FlowRunner";
const IntegrationMenuBar = () => {
  const [isOpen, setOpen] = useState(false);
  const flow = useSelector((state) => state.integration.flow);
  const saved = useSelector((state) => state.integration.saved);
  const navigate = useNavigate();
  const { flowId } = useParams();

  const onReturn = () => {
    if (!saved) setOpen(true);
    else navigate("/integration");
  };
  const discardChanges = () => {
    setOpen(false);
    dispatch(setEditorSaved(true));
    dispatch(selectFlow({}));
  };
  const toggleEnabled = () => {
    flow.enabled = !flow.enabled;
    dispatch(toggleLoading(true, "Loading..."));
    dispatch(saveFlow(flow));
  };
  const dispatch = useDispatch();

  let status = "";
  if (flow && flow.id && flow.enabled) {
    status = <Status text="ENABLED" color="green" />;
  } else if (flow && flow.id && !flow.enabled) {
    status = <Status text="DISABLED" color="red" />;
  }
  const toggleTooltipText = (flow.enabled ? "Disable" : "Enable") + " this flow";

  const isEditingFlow = Boolean(flowId);

  return (
    <div className="ihub-integration-bar">
      {!isEditingFlow && <h3>Integrations </h3>}
      {isEditingFlow && status}

      <div className="ihub-create-integration">
        {!isEditingFlow ? (
          <div className="ihub-create-integration">
            <CreateButton />
          </div>
        ) : (
          <>
            <FlowRunner />
            <div className="ihub-flow-run">
              <StopFlowButton />
              <Tooltip content="Test this flow (Flow must be enabled)">
                <TestFlowButton />
              </Tooltip>
            </div>

            <div className="ihub-flow-toggle-enable">
              <Tooltip content={toggleTooltipText}>
                <Toggle isChecked={flow.enabled} onChange={toggleEnabled} />
              </Tooltip>
            </div>
            <div className="ihub-flow-back-button">
              <Tooltip content="Back to integration flow list">
                <Button appearance="link" onClick={onReturn} iconBefore={ArrowLeftIcon}></Button>
              </Tooltip>
            </div>
            {!flow.enabled && <div className="ihub-create-integration"></div>}
          </>
        )}
      </div>
      <ConfirmModal
        action={"discard the changes"}
        targetName={flow.name}
        targetId={flow.id}
        isOpen={isOpen}
        onAction={discardChanges}
        onClose={() => setOpen(false)}
      />
    </div>
  );
};
export default IntegrationMenuBar;
